import { render, staticRenderFns } from "./comparison-config.vue?vue&type=template&id=98f28a38&"
import script from "./comparison-config.vue?vue&type=script&lang=ts&"
export * from "./comparison-config.vue?vue&type=script&lang=ts&"
import style0 from "./comparison-config.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports